<template>
  <div v-show="show">
    <div
      v-if="status && status.id"
      class="
        p-4
        fixed
        z-50
        rounded-lg
        border
        border-grey-700
        shadow-lg
        bg-dark
        text-grey-300
        text-sm
      "
      style="right: 1rem; bottom: 1rem; width: 360px"
    >
      <div class="w-full">
        <p>{{ $t('frontend_grooveblog_import_progress_importing') }}</p>
        <div class="mt-1 importing-bar" :style="progressBarColor">
          <div :style="{ width: `${importingLoader}%` }"></div>
        </div>
        <div class="importing-status flex flex-row items-center">
          <p v-html="importStatus"></p>
          <span class="cursor-pointer ml-1" v-if="importingLoader === 100" @click="goToListing">
            {{
              $t(
                importFailed
                  ? 'frontend_grooveblog_import_go_to_import_listing'
                  : 'frontend_grooveblog_import_go_to_blog_listing'
              )
            }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      blogId: null,
      status: null,
      show: false,
      intervalId: null,
    };
  },

  async created() {
    this.blogId = this.$store.getters.getBlogId;
    // Fetch status for recent import
    this.toggleShow(true);
  },

  computed: {
    /**
     * This computed property is used to set color for progress bar
     *
     * @return {string}
     */
    progressBarColor() {
      let color = 'var(--brand-primary)';
      if (this.status && this.status.importing_blog === 'failed') {
          color = 'red';
      } else if (this.status.no_of_discards > 0) {
        color = 'yellow';
      }
      return `--progress-color: ${color};`;
    },

    /**
     * This computed property is used to get completion percentage for progress bar
     *
     * @return {int}
     */
    importingLoader() {
      if (this.status) {
        if (['done', 'failed'].includes(this.status.importing_blog)) {
          return 100;
        }
        return (
          ((this.status.no_of_imports + this.status.no_of_discards) /
            this.status.no_of_posts) *
          100
        );
      }
      return 0;
    },

    /**
     * This computed property gets the importing status text
     *
     * @return {string}
     */
    importStatus() {
      let message = 'Importing initiated';

      if (this.status && this.status.importing_blog) {
        if (['done', 'failed'].includes(this.status.importing_blog)) {
          message = this.$t('frontend_grooveblog_import_progress_import_completed');
        } else {
          message = this.$t(
            'frontend_grooveblog_import_progress_importing_blog',
            {
              postTitle: this.status.importing_blog
            }
          );
        }
      }
      return message;
    },

    importFailed() {
      return (
        this.status.importing_blog === 'failed' ||
        (
          this.status.importing_blog === 'done' &&
          this.status.no_of_discards > 0
        )
      );
    }
  },

  methods: {
    /**
     * This method is used to toggle display for import progress component
     * Also to set or remove interval to fetch status for import
     *
     * @param {boolean} val
     * @return {void}
     */
    toggleShow(val) {
      this.show = val;

      // If component is to be shown
      if (val) {
        // Create interval if not existing already
        if (!this.intervalId) {
          this.intervalId = setInterval(
            this.getStatus,
            1000
          );
        }
      } else {
        // Remove interval when the component is hidden
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },

    /**
     * This method fetches status for import progress
     *
     * @return {void}
     */
    getStatus() {
      // Get status
      axios
        .get(`blogpost/${this.blogId}/import-status`)
        .then((response) => {
          if (response.data.data) {
            // Update status for import
            this.status = response.data.data;

            // Show component if import process is running
            this.toggleShow(this.status && this.status.id);

            // If import is processed and state is done/failed
            if (
              this.status &&
              this.status.status &&
              ['done', 'failed'].includes(this.status.importing_blog)
            ) {

              // Stop fetching import status
              clearInterval(this.intervalId);
              this.intervalId = null;

              // Hide component after 10 seconds
              setTimeout(() => {
                this.status = null;
              }, 10000);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },

    goToListing() {
      this.$router.push({
        name: this.importFailed ? 'list_imports' : 'list_post'
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.importing-bar {
  width: 100%;
  height: 2px;
  border-radius: 2px;
  background-color: var(--brand-secondary-light);
  margin-top: 15px;

  > div {
    width: 50%;
    background-color: var(--progress-color);
    height: 2px;
    box-shadow: 0 0 10px 1px var(--progress-color);
    border-radius: 2px;
    -webkit-animation: glow 1s ease-in-out infinite alternate;
    -moz-animation: glow 1s ease-in-out infinite alternate;
    animation: glow 1s ease-in-out infinite alternate;
  }
}

.importing-status {
  font-size: 12px;
  margin-top: 6px;
  color: #b9bbcb;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
}
</style>
